<template>
<div class="grid-content">
  <div class="main-section">
    <div class="card big-paddings">

      <div class="page-title">
        <p>INICIO > PREGUNTAS FRECUENTES</p>
        <h1>Preguntas frecuentes</h1>
      </div>

      <p class="pointer" @click="ChangeState({gofarma:!questions.gofarma})"><strong>¿Qué es GoFarma?<i v-if="questions.gofarma===false" class="fa fa-angle-right arrow-dropdown" ></i> <i v-if="questions.gofarma===true" class="fa fa-angle-down arrow-dropdown"></i></strong></p>
      <div v-if="questions.gofarma===true">
        <p>Somos una farmacia exclusivamente a domicilio con  cobertura en toda la Zona Metropolitana de Monterrey.Nuestro compromiso es ofrecer el medicamento que necesites, 
          a un precio bajo y sin cargos adicionales hasta donde estés. También contamos con envíos nacionales y atención a empresas. 
          Para más información, escríbenos a empresas@gofarma.com</p>
      </div>

     
      <p class="pointer" @click="ChangeState({location:!questions.location})"><strong>¿En dónde están ubicados?<i v-if="questions.location===false" class="fa fa-angle-right arrow-dropdown" ></i> <i v-if="questions.location===true" class="fa fa-angle-down arrow-dropdown"></i></strong></p>
      <div v-if="questions.location===true">
        <p>No contamos con un mostrador al que tengas que acudir, ya que brindamos servicio exclusivamente a domicilio a toda la Zona Metropolitana de Monterrey. 
          Contamos con almacenes ubicados estratégicamente para llegar rápidamente hasta donde estés.</p>
      </div>

      <p class="pointer" @click="ChangeState({hour:!questions.hour})"><strong>¿Cuál es el horario de atención?<i v-if="questions.hour===false" class="fa fa-angle-right arrow-dropdown"></i> <i v-if="questions.hour===true" class="fa fa-angle-down arrow-dropdown" ></i></strong></p>
      <div v-if="questions.hour===true">
        <p>Estamos disponibles las 24 horas por teléfono, WhatsApp, Inbox, y a través de gofarma.com Los envíos también son 24 horas. Es decir, 
          puedes pedir tu medicamento a cualquier hora de la madrugada y lo llevaremos hasta donde estés.</p>
      </div>

      <p class="pointer" @click="ChangeState({shipping:!questions.shipping})"><strong>¿El envío también es 24 horas?<i v-if="questions.shipping===false" class="fa fa-angle-right arrow-dropdown" ></i> <i v-if="questions.shipping===true" class="fa fa-angle-down arrow-dropdown" ></i></strong></p>
      <div v-if="questions.shipping===true">
        <p>¡Claro! Llevamos tu pedido hasta donde estés las 24 horas. No importa si es de día, de noche o de madrugada. Entendemos la 
          importancia de tu bienestar.</p>
      </div>

      <p class="pointer" @click="ChangeState({order:!questions.order})"><strong>¿Puedo programar un pedido?<i v-if="questions.order===false" class="fa fa-angle-right arrow-dropdown" ></i></strong></p>
      <div v-if="questions.order===true">
        <p>Así es, puedes programar un pedido con la fecha y hora en que deseas recibirlo.</p>
      </div>

      <p class="pointer" @click="ChangeState({service:!questions.service})"><strong>¿Cuentan con servicio a domicilio?<i v-if="questions.service===false" class="fa fa-angle-right arrow-dropdown"></i> <i v-if="questions.service===true" class="fa fa-angle-down arrow-dropdown" ></i></strong></p>
      <div v-if="questions.service===true">
        <p>Sí, nuestro servicio es exclusivamente a domicilio, sin cargo por envío, sin mínimo de compra, las 24 horas, y el pago se 
          realiza al momento de recibir el pedido.</p>
      </div>

      <p class="pointer" @click="ChangeState({cost:!questions.cost})"><strong>¿Hay monto mínimo de compra?<i v-if="questions.cost===false" class="fa fa-angle-right arrow-dropdown"></i> <i v-if="questions.cost===true" class="fa fa-angle-down arrow-dropdown" ></i></strong></p>
      <div v-if="questions.cost===true">
        <p>No te pedimos un monto mínimo de compra. Puedes pedir tu medicamento (sea cual sea el precio) y te lo llevaremos hasta tu domicilio. 
          Sí.. ¡leíste bien! Puedes pedir algo de $3.00 y te lo llevamos a tu destino. Nos encanta servirte</p>
      </div>
      
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name:'questions',
  methods:{
    ChangeState(obj){
      let questions = this.questions
            let keys = Object.keys(obj)
            questions[keys] = obj[keys]
            this.$store.commit('StateAssign', {questions})
    }
  },
  computed:{
    ...mapState(['questions'])
  }
}
</script>

<style scoped>
  .card:hover {
    box-shadow: 0 0rem 0rem 0 rgba(0, 0, 0, 0.0);
  }

  .card {
    box-shadow: none;  
  }
</style>
